<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="caption">
          {{ indicador.indicador.nombre }}, {{ $t('label_norma', [norma]) | capitalize }}
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="6">
        <v-select v-model="tipoSeleccionado" item-value="valor" item-text="texto" :items="tiposPosibles"
                  hide-details @change="cambiaTipo()" :append-icon="tiposPosibles.length < 2 ? '' : '$dropdown'"/>
      </v-col>
      <v-col cols="6">
        <v-text-field v-if="seleccionadoEsRango" v-model="rango" type="number" hide-details
                      :class="!rango ? 'grey lighten-4' : undefined" :label="`${indicador.rangoDatos.unidades}`"
                      @change="cambiaRango()"/>

        <v-select v-if="!seleccionadoEsRango" v-model="clase" item-value="valor" item-text="texto"
                  :items="posiblesClases" :class="!clase ? 'grey lighten-4' : undefined" hide-details
                  @change="cambiaClase()"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "IndicadorPrestacional",
  props: {
    indicador: {type: Object, required: true},
    prestacion: {type: Object, required: true},
  },
  data: function () {
    return {
      tipoSeleccionado: null,
      rango: null,
      clase: null
    }
  },
  mounted() {
    this.inicializarSeleccion();
  },
  watch: {
    prestacion: {
      handler() {
        this.inicializarSeleccion();
      },
      deep: true
    }
  },
  computed: {
    tiposPosibles: function () {
      let tipos = [];

      if (this.indicador.rango) {
        tipos.push({
          valor: "rango",
          texto: `Introduce un valor (${this.indicador.rangoDatos.unidades})`
        });
      }

      if (this.indicador.opciones.length > 0)
        tipos.push({
          valor: "clase",
          texto: `Selecciona una clase`
        });

      return tipos;
    },
    posiblesClases() {
      let clases = [];

      this.indicador.opciones.forEach((opcion) => {
        clases.push({
          valor: opcion.valor,
          texto: this.calcularOpcionTexto(opcion),
          norma: opcion.norma
        });
      });

      return clases;
    },
    seleccionadoEsRango: function () {
      if (this.tipoSeleccionado == null) return false;
      return this.tipoSeleccionado === "rango";
    },
    norma() {
      if (this.tipoSeleccionado === "rango") {
        return this.indicador.rangoDatos.norma;
      } else {
        let norma = null;
        let primeraNormal = null;
        this.indicador.opciones.forEach((opcion) => {
          if (this.clase === opcion.valor) norma = opcion.norma;
          if (primeraNormal == null && opcion.norma != null) primeraNormal = opcion.norma;
        });
        return norma ? norma : primeraNormal;
      }
    }
  },
  methods: {
    inicializarSeleccion() {
      let codigo = this.indicador.indicador.codigo;
      let defecto = Object.prototype.hasOwnProperty.call(this.prestacion, codigo) ? this.prestacion[codigo] : null;
      this.seleccionarValorDefecto(this.indicador, defecto);
    },
    calcularOpcionTexto(option) {
      switch (option.valor.trim().toLowerCase()) {
        case "dnd":
          return "Dato no disponible";
        case "dna":
          return "Dato no aplicable";
        default:
          return `${option.valor} (${option.unidades})`;
      }
    },
    seleccionarValorDefecto(indicador, valorDefecto) {
      if (valorDefecto == null) {
        this.tipoSeleccionado = this.tiposPosibles.length > 0 ? this.tiposPosibles[0].valor : null;
        this.rango = null;
        this.clase = null;
        return;
      }

      valorDefecto = valorDefecto.trim();

      let esClase = false;
      indicador.opciones.forEach((opcion) => {
        if (opcion.valor == valorDefecto) {
          this.tipoSeleccionado = "clase";
          this.clase = opcion.valor;
          this.rango = null;
          esClase = true;
        }
      });

      if (!esClase && indicador.rango) {
        this.tipoSeleccionado = 'rango';
        this.rango = Number(valorDefecto.replace(",", "."));
        this.clase = null;
      }
    },
    cambiaTipo() {
      this.eliminarPrestacion();

      switch (this.tipoSeleccionado) {
        case "rango":
          this.asignarPrestacion(this.rango);
          break;
        case "clase":
          this.asignarPrestacion(this.clase);
          break;
        default:
          this.asignarPrestacion(this.tipoSeleccionado);
      }
    },
    cambiaClase() {
      this.asignarPrestacion(this.clase);
    },
    cambiaRango() {
      this.asignarPrestacion(this.rango);
    },
    asignarPrestacion(value) {
      let codigo = this.indicador.indicador.codigo;
      this.prestacion[codigo] = value;
    },
    eliminarPrestacion() {
      let codigo = this.indicador.indicador.codigo;
      delete this.prestacion[codigo];
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "label_norma": "norma: {0}"
  }
}
</i18n>
<!--@formatter:oon-->